import React, { Component } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { Button, withStyles, Typography, Switch, TextField } from '@material-ui/core'
import compose from 'recompose/compose'
import { connect } from 'react-redux'
import treeChanges from 'tree-changes'
import _ from 'lodash'

import {
  Portlet,
  PortletHeader,
  PortletLabel,
  PortletContent,
  PortletFooter
} from 'components'
import styles from './style'
import { updateShopSettings, showAlert } from 'redux/actions'
import { STATUS } from 'redux/constants'

class Payment extends Component {
  constructor (props) {
    super(props)
    const shopSettings = props.settings.data
    this.state = {
      shopSettings,
      touched: false
    }
  }

  componentWillReceiveProps = newProps => {
    const { settings, updateShop } = _.cloneDeep(newProps)
    const { changed, changedTo } = treeChanges(this.props, newProps)
    if (changed('settings') && updateShop.status !== STATUS.RUNNING) {
      this.setState({ shopSettings: _.cloneDeep(settings.data) })
    }
    if (changedTo('updateShop.status', STATUS.ERROR) && updateShop.type === 'settings') {
      this.props.dispatch(showAlert(updateShop.message, { variant: 'error' }))
    } else if (changedTo('updateShop.status', STATUS.READY) && updateShop.type === 'settings') {
      this.setState({ touched: false })
      this.props.dispatch(showAlert('Updated Shop Reservation Settings successfully', { variant: 'success' }))
    }
  }

  handleReservationSettingsChange = (e, field) => {
    const { checked } = e.target
    let { shopSettings } = this.state
    shopSettings.settings[field] = checked
    this.setState({ shopSettings, touched: true })
  }

  handleReservationSettingsInputChange = (field, value) => {
    let { shopSettings } = this.state
    shopSettings.settings[field] = value
    this.setState({ shopSettings, touched: true })
  }

  handleSaveAction = e => {
    const { shopSettings } = this.state
    const request = {
      info: shopSettings.info,
      payment_details: shopSettings.payment_details,
      settings: {
        booking: shopSettings.settings.booking,
        booking_buffer: shopSettings.settings.booking_buffer,
        booking_days: shopSettings.settings.booking_days,
        booking_limited: shopSettings.settings.booking_limited,
        booking_request: shopSettings.settings.booking_request
      }
    }
    this.props.dispatch(updateShopSettings(this.props.shopId, { shop: request }, 'settings'))
  }

  render () {
    const { classes, className, updateShop, ...rest } = this.props
    const { shopSettings, touched } = this.state
    const rootClassName = classNames(classes.root, className)

    return (
      <Portlet
        {...rest}
        className={rootClassName}
      >
        <PortletHeader>
          <PortletLabel
            subtitle='The information can be edited'
            title='Reservation Settings'
          />
        </PortletHeader>
        <PortletContent noPadding>
          <form
            autoComplete='off'
            noValidate
          >
            <div className={classes.field}>
              <div className={classes.acceptStatus}>
                <Typography className={classes.statusTitle} variant='body1'>Booking Enabled</Typography>
                <Switch
                  className={classes.switch}
                  checked={shopSettings.settings.booking}
                  onChange={(e) => this.handleReservationSettingsChange(e, 'booking')}
                  value='checkedA'
                  // disabled={isLoading}
                  inputProps={{ 'aria-label': 'primary checkbox' }}
                />
              </div>
            </div>
            <div className={classes.field}>
              <div className={classes.acceptStatus}>
                <TextField
                  className={classes.textField}
                  label='Booking Buffer(Hours)'
                  margin='dense'
                  value={shopSettings.settings.booking_buffer}
                  variant='outlined'
                  type='number'
                  onChange={(e) => this.handleReservationSettingsInputChange('booking_buffer', e.target.value)}
                  fullWidth
                />
              </div>
            </div>
            <div className={classes.field}>
              <div className={classes.acceptStatus}>
                <TextField
                  className={classes.textField}
                  label='Booking Days'
                  margin='dense'
                  value={shopSettings.settings.booking_days}
                  variant='outlined'
                  type='number'
                  onChange={(e) => this.handleReservationSettingsInputChange('booking_days', e.target.value)}
                  fullWidth
                />
              </div>
            </div>
            <div className={classes.field}>
              <div className={classes.acceptStatus}>
                <Typography className={classes.statusTitle} variant='body1'>Booking Request Enabled</Typography>
                <Switch
                  className={classes.switch}
                  checked={shopSettings.settings.booking_request}
                  onChange={(e) => this.handleReservationSettingsChange(e, 'booking_request')}
                  value='checkedA'
                  // disabled={isLoading}
                  inputProps={{ 'aria-label': 'primary checkbox' }}
                />
              </div>
            </div>
            <div className={classes.field}>
              <div className={classes.acceptStatus}>
                <Typography className={classes.statusTitle} variant='body1'>Booking Limited</Typography>
                <Switch
                  className={classes.switch}
                  checked={shopSettings.settings.booking_limited}
                  onChange={(e) => this.handleReservationSettingsChange(e, 'booking_limited')}
                  value='checkedA'
                  // disabled={isLoading}
                  inputProps={{ 'aria-label': 'primary checkbox' }}
                />
              </div>
            </div>
          </form>
        </PortletContent>
        <PortletFooter className={classes.portletFooter}>
          <Button
            color='primary'
            variant='contained'
            onClick={this.handleSaveAction}
            disabled={!touched || (updateShop.status === STATUS.RUNNING && updateShop.type === 'settings')}
          >
            Save Settings
          </Button>
        </PortletFooter>
      </Portlet>
    )
  }
}

Payment.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    settings: _.cloneDeep(state.shops.settings),
    updateShop: state.shops.updateSettings
  }
}

export default compose(
  withStyles(styles)
)(connect(mapStateToProps)(Payment))
